


$(function($){
  AOS.init();
  /* Scroll Position */
  function scroll(){
    var $height = $(window).scrollTop();
    if($height > 50) {
      $('#fixedTop').addClass('active'); 
    } else {
      $('#fixedTop').removeClass('active');
    }
    
    if($height < 100) {
      $('#notification').addClass('active'); 
    } else {
      $('#notification').removeClass('active');
    }
  }
  scroll();
  $(window).scroll(function() {
    scroll();
  });
  /* Scroll Down Click */
  $('.scrollDown').on('click', function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: $('#sliderHome').height()
    }, 700);
  });


  $(window).scroll(function(e){
    var scrollTop = $(window).scrollTop();
    var docHeight = $(document).height();
    var winHeight = $(window).height();
    var scrollPercent = (scrollTop) / (docHeight - winHeight);
    var scrollPercentRounded = Math.round(scrollPercent*100);
    $('#scrollPercent').width(scrollPercentRounded+'%');
  });


  $('body').on('click','.qtybox .btnqty', function(){
    var t = $(this);
    var input = $(this).parent('.qtybox').find('.quantity-input');
    var qty = parseInt(input.val());
    if($(this).hasClass('qtyplus')) {
      qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    input.val(qty);
    
    var productId = t.attr('data-productId'); 
   	updateQty(input, qty, productId);
    if(productId !== null && productId !== '' ){
      console.log('YOK');
    }else{
      
    }
    
    //var productId = t.attr('data-id'); 
    //console.log($(this).parent('.qtybox').html());
    
  });
  function updateQty(input, qty, productId) {
    
    console.log('input '+JSON.stringify(input));
    console.log('qty '+qty);
    console.log('productId '+productId);
    $('#wait').fadeIn();
    
 
      jQuery.post('/cart/change.js', { quantity: qty, id: productId }, null, "json")
      .done(function(response) {
        var total = Shopify.formatMoney(response.total_price,'{\{amount\}\} \SR');
        var subtotal = Shopify.formatMoney(response.items_subtotal_price,'{\{amount\}\} \SR');
        var itemCount = response.item_count;
        jQuery('#cartBox .total span').text(total);
        jQuery('#cartBox .checkout span').text(total);
        jQuery('#cartBox .subtotal span').text(subtotal);
        jQuery('#cartBox .itemCount span').text(itemCount);
        jQuery('#cartPage .total span').text(total);
        jQuery('#cartPage .checkout span').text(total);
        jQuery('#cartPage .subtotal span').text(subtotal);
        jQuery('#cartPage .itemCount span').text(itemCount);
        jQuery('#fixedTop .cartView span').text(itemCount);
        // console.log(response);
        $('#wait').fadeOut();
      })
      .fail(function(xhr, status, error) {
        // error handling
        // console.log(error);
      })
      .always(function() {
        setTimeout(function() {
          input.parent().removeClass('loading');
        }, 1000);
      });
   
    
  }


})
 


 document.addEventListener("DOMContentLoaded", function() {
   let windowHeight = window.innerHeight;
   
  var lazyloadImages = document.querySelectorAll("img.lazy");    
  var lazyloadThrottleTimeout;
  
  function lazyload () {
    if(lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }    
    
    lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
            if(img.offsetTop <  (window.innerHeight + scrollTop) || img.offsetTop <  windowHeight) {  
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
    }, 20);
  }
  document.addEventListener("scroll", lazyload);
  window.addEventListener("resize", lazyload);
  window.addEventListener("orientationChange", lazyload); 
  lazyload ();
var lazyBgloadImages = document.querySelectorAll(".lazyBg");    
 var lazyBgloadThrottleTimeout;
 
 function lazyBgload () {
   if(lazyBgloadThrottleTimeout) {
     clearTimeout(lazyBgloadThrottleTimeout);
   }    
   
   lazyBgloadThrottleTimeout = setTimeout(function() {
       var scrollTop = window.pageYOffset;
       lazyBgloadImages.forEach(function(bg) {
           if(bg.offsetTop < (window.innerHeight + scrollTop) || bg.offsetTop <  windowHeight) { 
             //bg.style = 'background-image:url(https:' + bg.dataset.src + ')'; 
             var bgLink = 'https:' + bg.dataset.src ;
             bg.style.backgroundImage = 'url( ' + bgLink + ')'; 
             //console.log(bgLink);
             bg.classList.remove('lazy');
           }
       });
       if(lazyBgloadImages.length == 0) { 
         document.removeEventListener("scroll", lazyBgload);
         window.removeEventListener("resize", lazyBgload);
         window.removeEventListener("orientationChange", lazyBgload);
       }
   }, 20);
 }
 
 document.addEventListener("scroll", lazyBgload);
 window.addEventListener("resize", lazyBgload);
 window.addEventListener("orientationChange", lazyBgload);
   lazyBgload ();
});